module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece04.7b2772a29d396fc98ef1a5db36459dc6.png";